import domWrap from "../utils/domWrap";
import h from "../utils/htm";

export default async truckHero => { // 'comp-truck-hero'
	const 	cabs = [...truckHero.querySelectorAll(':scope > .cabs > img')],
			tabHolder = truckHero.querySelector(':scope > .cab-tabs'),
			// tabs = [...tabHolder.querySelectorAll('button')],
			selected = cabs.findIndex(item => document.referrer.indexOf(item.getAttribute('name').toLowerCase().split(' ').join('-')) !== -1);

	if(selected !== -1){
		activate({cabs,tabs,index:selected});
		[...truckHero.querySelectorAll(':scope > .cabs > img.active')].forEach(img => {
			img.addEventListener('load',truckHero.classList.add('loaded'));
			if(img.complete) truckHero.classList.add('loaded');
		});
	}
	else{
		[...truckHero.querySelectorAll(':scope > img')].forEach(img => {
			img.addEventListener('load',truckHero.classList.add('loaded'));
			if(img.complete) truckHero.classList.add('loaded');
		});
	}

	// Loaded fallback
	setTimeout(() => truckHero.classList.add('loaded'),1500);

	domWrap(tabHolder).on('click','button',function(){
		activate({index:this.classList.contains('on') ? selected : parseInt(this.getAttribute('index')),cabs,tabs});
	});

	[...document.querySelectorAll('comp-truck-hero .specs .row > div')].forEach(element => element.innerHTML = element.textContent.split('(').reduce((html,cur) => {
		const split = cur.split(')');
		return html + (split.length > 1 ? h('i class="icon-plus-icon" title="'+split[0]+'"') : split[0]);
	},''));
};

function activate({cabs,tabs,index}){
	domWrap(cabs[index]).setSelected('active');
	domWrap(tabs[index]).setSelected('on');
}